import * as svg from "../../../assets/envelope-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const EnvelopeIcon = iconBuilder(svg, "EnvelopeIcon", "0 0 16 16");
